module.exports = __webpack_public_path__ + "media/crazyclown.d99454d4.wav";